import { Translation, QRType } from '../types';

export const vi: Translation = {
  nav: {
    generator: 'Tạo mã',
    scanner: 'Quét mã',
    mobile: 'Thử trên di động',
    blog: 'Blog',
    langSelect: 'Chọn ngôn ngữ',
  },
  pageTitles: {
    generator: 'Trình tạo QR miễn phí trực tuyến',
    scanner: 'Trình quét QR trực tuyến',
    textToQr: 'Chuyển văn bản sang QR',
    linkToQr: 'Tạo QR từ liên kết',
  },
  pageMeta: {
    generator: {
      title:
        'Trình tạo mã QR miễn phí — Tạo QR online (không đăng ký, không watermark, PNG/SVG/PDF) | YesQRCode',
      description:
        'Tạo mã QR online miễn phí với YesQRCode. Hỗ trợ URL, văn bản, Wi‑Fi, vCard và nhiều loại khác. Tải xuống PNG, SVG hoặc PDF chất lượng cao. Không đăng ký, không đăng nhập, không watermark — nhanh, an toàn và miễn phí mãi mãi.',
      keywords: [
        'trình tạo mã qr',
        'tạo mã qr miễn phí',
        'tạo qr online',
        'công cụ tạo qr',
        'qr png',
        'qr svg',
        'qr pdf',
        'tạo qr wifi',
        'tạo qr vcard',
        'tạo qr không cần đăng ký',
      ],
    },
    scanner: {
      title:
        'Trình quét QR online — Quét từ ảnh hoặc camera (an toàn, không đăng ký) | YesQRCode',
      description:
        'Quét mã QR và mã vạch miễn phí trực tuyến. Tải ảnh lên hoặc dùng camera. Mọi xử lý đều diễn ra trên thiết bị, không upload. An toàn, nhanh, không đăng ký, không đăng nhập và hoàn toàn miễn phí.',
      keywords: [
        'trình quét qr',
        'quét qr online',
        'đọc qr online',
        'quét qr từ ảnh',
        'quét mã vạch online',
        'quét qr an toàn',
        'quét qr không upload',
        'quét qr miễn phí',
        'quét qr trên trình duyệt',
        'quét qr không cần đăng ký',
      ],
    },
    textToQr: {
      title: 'Văn bản sang QR | Biến ghi chú thành mã QR',
      description:
        'Chuyển đoạn văn bản, ghi chú hoặc tin nhắn thành mã QR dễ chia sẻ. Tùy biến theo thương hiệu và xuất PNG, SVG hoặc PDF ngay lập tức mà không cần đăng ký.',
      keywords: ['văn bản sang qr', 'tạo qr từ văn bản', 'qr ghi chú', 'qr tin nhắn', 'chuyển qr online', 'qr văn bản miễn phí'],
    },
    linkToQr: {
      title: 'Liên kết sang QR | Chuyển URL thành mã QR',
      description:
        'Dán URL website hoặc chiến dịch và tạo ngay mã QR theo thương hiệu để in ấn hoặc dùng số. Hỗ trợ màu tùy chỉnh, logo và tải xuống độ phân giải cao.',
      keywords: ['liên kết sang qr', 'tạo qr url', 'qr cho website', 'qr cho liên kết', 'utm qr', 'tải qr pdf'],
    },
  },
  hero: {
    title: 'Tạo mã QR riêng tư, sẵn sàng cho thương hiệu — miễn phí mãi mãi.',
    subtitle: 'Công cụ QR nhanh, riêng tư và linh hoạt cho mọi quy trình.',
    desc: 'Tạo và quét mã QR chất lượng cao mà không cần tài khoản, không watermark, không upload dữ liệu.',
    ctaPrimary: 'Tạo mã QR',
    ctaSecondary: 'Thử trên di động',
  },
  info: {
    helpTitle: 'Trung tâm trợ giúp',
    helpSubtitle: 'Câu hỏi thường gặp & Hỗ trợ',
    contactTitle: 'Liên hệ',
    contactSubtitle: 'Chúng tôi rất muốn lắng nghe bạn.',
    privacyTitle: 'Chính sách quyền riêng tư',
    termsTitle: 'Điều khoản dịch vụ',
  },
  contactForm: {
    name: 'Tên',
    email: 'Email',
    message: 'Tin nhắn',
    send: 'Gửi',
    orEmail: 'hoặc gửi email trực tiếp tới',
    sending: 'Đang gửi...',
    successTitle: 'Đã gửi!',
    successMessage: 'Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi sớm.',
    sendAnother: 'Gửi tin nhắn khác',
    errorMessage: 'Hiện không thể gửi tin nhắn. Vui lòng email support@yesqrcode.com.',
  },
  generator: {
    highlights: {
      title: 'Tạo mã QR riêng tư, sẵn sàng cho thương hiệu — miễn phí mãi mãi.',
      subtitle: 'Công cụ QR nhanh, riêng tư và linh hoạt cho mọi quy trình.',
      items: [
        {
          title: 'Ưu tiên riêng tư, tạo trên thiết bị',
          desc: 'Mã QR được tạo cục bộ — không upload, không theo dõi, không lưu dữ liệu.',
        },
        {
          title: 'Đầy đủ tính năng cho mọi nhu cầu',
          desc: 'URL, Wi‑Fi, vCard, mã vạch, logo, gradient, khung — tất cả đều có sẵn.',
        },
        {
          title: 'Thân thiện di động, dễ dùng cho mọi người',
          desc: 'Tối ưu cho điện thoại và thao tác chạm để tạo và quét mượt mà.',
        },
        {
          title: 'Miễn phí mãi mãi, an toàn cho thương mại',
          desc: 'Không tài khoản, không watermark, không giới hạn quét — phù hợp cho đội nhóm và doanh nghiệp.',
        },
      ],
    },
    featureSuite: {
      title: 'Bộ công cụ QR đầy đủ, ưu tiên riêng tư',
      subtitle: 'Tất cả những gì bạn cần để tạo mã QR gọn gàng, đúng thương hiệu, chất lượng cao — trong một nơi.',
      categories: [
        {
          title: 'Tất cả loại QR bạn cần',
          body: 'URL, Văn bản, Wi‑Fi, Email, Điện thoại, SMS, vCard, liên kết mạng xã hội, YouTube, mã vạch. Mã tĩnh không bao giờ hết hạn.',
          items: [],
        },
        {
          title: 'Thương hiệu & Thiết kế',
          body: 'Mã an toàn khi chèn logo, gradient, khung, hình dạng, góc, bố cục tối ưu cho quét.',
          items: [],
        },
        {
          title: 'Xuất & Chất lượng',
          body: 'Xuất PNG, SVG và PDF chất lượng cao, có preset cho in ấn và digital.',
          items: [],
        },
        {
          title: 'Toàn cầu & Dễ dùng',
          body: 'Giao diện đa ngôn ngữ, thiết kế ưu tiên di động, quy trình thân thiện khi offline.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Được tin dùng bởi người sáng tạo, đội nhóm và thương hiệu',
      subtitle:
        'YesQRCode được thiết kế nhẹ, ổn định và an toàn cho các chiến dịch dài hạn — không tài khoản, không khóa nhà cung cấp, không giới hạn ẩn.',
      items: ['Không cần onboarding', 'Mã tĩnh ổn định', 'An toàn cho doanh nghiệp: không xử lý trên cloud', 'Thương hiệu nhất quán trên mọi tài sản'],
    },
    sectionContent: 'Nội dung',
    sectionColors: 'Màu sắc',
    sectionLogo: 'Logo',
    sectionFrame: 'Khung',
    sectionDesign: 'Thiết kế',
    sectionCorrection: 'Sửa lỗi',
    labelUrl: 'URL website',
    labelText: 'Văn bản',
    labelSsid: 'Tên mạng (SSID)',
    labelPassword: 'Mật khẩu',
    labelEncryption: 'Mã hóa',
    labelFgColor: 'Màu trước',
    labelBgColor: 'Màu nền',
    labelFrameText: 'Câu trên khung',
    labelFrameColor: 'Màu khung',
    placeholder: 'Nhập nội dung ở đây...',
    placeholders: {
      url: 'https://example.com',
      text: 'Nhập văn bản',
      email: 'ban@email.com',
      subject: 'Tiêu đề',
      message: 'Nội dung...',
      phone: '+84 90 123 4567',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'Tải PNG',
    downloadSvg: 'Tải SVG',
    generateButton: 'Tạo mã QR',
    copy: 'Sao chép SVG',
    uploadLogo: 'Tải ảnh lên',
    preview: 'Xem trước',
    lowQuality: 'Chất lượng thấp',
    highQuality: 'Chất lượng cao',
    foreverFree: 'Miễn phí mãi mãi • Không đăng ký • Dùng thương mại',
    barcodeWarning: 'Các tùy chọn nâng cao như Khung và Logo không khả dụng cho Mã vạch.',
    barcodeColors: 'Bạn vẫn có thể tùy chỉnh Màu sắc bên dưới.',
    frameStyles: {
      none: 'Không',
      simple: 'Đơn giản',
      balloon: 'Bong bóng',
      box: 'Hộp',
      badge: 'Huy hiệu',
      polaroid: 'Polaroid',
      phone: 'Điện thoại',
      header: 'Tiêu đề',
      corner: 'Góc',
    },
    vCard: {
      firstName: 'Tên',
      lastName: 'Họ',
      mobile: 'Di động',
      phone: 'Điện thoại',
      fax: 'Fax',
      email: 'Email',
      company: 'Công ty',
      job: 'Chức danh',
      street: 'Địa chỉ',
      city: 'Thành phố',
      zip: 'Mã bưu chính',
      state: 'Tỉnh/Bang',
      country: 'Quốc gia',
      website: 'Website',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Văn bản',
      [QRType.EMAIL]: 'Email',
      [QRType.PHONE]: 'Điện thoại',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Mã vạch',
    },
    guide: {
      title: 'Cách tạo mã QR tùy chỉnh?',
      steps: [],
    },
    gettingStarted: {
      title: 'Cách dùng',
      steps: [
        {
          title: 'Thiết lập nội dung',
          text: 'Chọn loại nội dung ở phía trên (URL, Văn bản, Email...). Sau khi chọn, bạn sẽ thấy các tùy chọn. Nhập đầy đủ các trường cần hiển thị khi quét mã. Hãy kiểm tra kỹ vì bạn không thể thay đổi nội dung sau khi mã được in.',
        },
        {
          title: 'Tùy chỉnh thiết kế',
          text: 'Muốn mã QR trông khác biệt? Hãy đặt màu tùy chỉnh và thay đổi các hình dạng tiêu chuẩn. Phần góc và thân mã có thể tùy chỉnh riêng. Thêm logo từ thư viện hoặc tải logo của bạn lên.',
        },
        {
          title: 'Tạo mã QR',
          text: 'Điều chỉnh độ phân giải pixel bằng thanh trượt. Nhấn “Tải xuống” để lưu mã QR. Hãy quét bản xem trước để chắc chắn mã hoạt động. Dùng độ phân giải cao nếu bạn cần PNG chất lượng in.',
        },
        {
          title: 'Tải ảnh',
          text: 'Bạn có thể tải mã QR dưới dạng .png, .svg hoặc .pdf. Nếu muốn định dạng vector kèm thiết kế đầy đủ, hãy chọn .svg. SVG làm việc tốt trong Adobe Illustrator hoặc Inkscape. Logo và một số thiết lập thiết kế hiện chỉ hoạt động cho .png và .svg.',
        },
      ],
    },
    about: {
      title: 'Bộ công cụ QR miễn phí, ưu tiên riêng tư',
      subtitle:
        'Tạo và quét mã QR chất lượng cao mà không cần tài khoản, không watermark, không upload dữ liệu. Tối ưu cho in ấn, thương hiệu và sử dụng thương mại.',
      features: [
        'Hỗ trợ các loại phổ biến: URL, Văn bản, Wi‑Fi, vCard, SMS và mã vạch',
        'An toàn khi chèn logo với khả năng sửa lỗi lên đến 30%',
        'Hình dạng, gradient, màu sắc và khung tùy chỉnh',
        'Mã QR tĩnh không bao giờ hết hạn',
        'Giao diện đa ngôn ngữ cho đội nhóm toàn cầu',
      ],
      content: [
        {
          title: 'QR an toàn khi chèn logo',
          body: 'Thêm logo mà không lo lỗi quét. Với khả năng sửa lỗi lên đến 30%, phần phủ thương hiệu vẫn dễ đọc trên bao bì, menu và biển hiệu.',
        },
        {
          title: 'Hình dạng và khung tùy chỉnh',
          body: 'Thay đổi hình góc, áp dụng gradient và chọn khung phù hợp chiến dịch. Các điều khiển tập trung thiết kế giúp mã vừa đẹp vừa dễ quét.',
        },
        {
          title: 'Nhiều loại nội dung',
          body: 'Tạo mã URL, văn bản, Wi‑Fi, vCard, SMS và mã vạch ở một nơi, kèm preset giúp thiết lập nhanh cho từng định dạng.',
        },
        {
          title: 'Mã tĩnh bền vững',
          body: 'Tạo mã QR tĩnh không hết hạn và không giới hạn lượt quét — lý tưởng cho chiến dịch dài hạn và tài sản in ấn.',
        },
      ],
    },
    faq: {
      title: 'Câu hỏi thường gặp',
      items: [
        {
          q: 'Mã QR là gì?',
          a: 'QR là viết tắt của Quick Response Code, một dạng mã vạch do Denso Wave phát minh năm 1994.',
        },
        {
          q: 'Tôi có thể dùng mã QR đã tạo cho mục đích thương mại không?',
          a: 'Có. Tất cả mã QR bạn tạo bằng công cụ này đều miễn phí và có thể dùng cho bất kỳ mục đích nào.',
        },
        {
          q: 'Mã QR đã tạo có hết hạn không?',
          a: 'Không. Chúng không hết hạn và sẽ hoạt động mãi mãi! Mã QR tạo bằng YesQRCode là mã tĩnh và không ngừng hoạt động theo thời gian. Tuy nhiên bạn không thể chỉnh sửa nội dung sau khi tạo.',
        },
        {
          q: 'Có giới hạn lượt quét không?',
          a: 'Không có giới hạn và mã QR sẽ hoạt động mãi mãi. Quét bao nhiêu lần tùy thích!',
        },
        {
          q: 'YesQRCode có lưu dữ liệu của tôi không?',
          a: 'Chúng tôi không lưu hoặc tái sử dụng dữ liệu của bạn dưới bất kỳ hình thức nào. Để tối ưu hiệu năng, chúng tôi có thể cache file ảnh QR trong 24 giờ trên máy chủ.',
        },
        {
          q: 'Vì sao vCard QR của tôi không hiển thị đúng trường?',
          a: 'Không phải mọi ứng dụng quét đều tuân thủ chuẩn vCard chính thức, dẫn đến các trường liên hệ bị lệch. Hãy thử ứng dụng quét khác để có kết quả tốt hơn.',
        },
        {
          q: 'Mã QR của tôi không hoạt động, tôi nên làm gì?',
          a: 'Có nhiều nguyên nhân. Trước hết hãy kiểm tra dữ liệu nhập: lỗi chính tả nhỏ trong URL cũng có thể làm hỏng mã. Một số loại (như vCard) chứa nhiều dữ liệu; hãy giảm bớt nếu có thể. Thử bỏ logo. Đồng thời đảm bảo độ tương phản đủ: phần trước phải luôn tối hơn nền.',
        },
        {
          q: 'YesQRCode có chạy trên mọi trình duyệt không?',
          a: 'YesQRCode cần trình duyệt hiện đại hỗ trợ HTML5 và chính thức hỗ trợ Chrome, Firefox, Safari, Edge và Internet Explorer 11.',
        },
      ],
    },
  },
  scanner: {
    title: 'Quét QR & mã vạch',
    subtitle: 'Dùng camera, tải ảnh lên hoặc dán để giải mã QR và mã vạch ngay lập tức.',
    cameraPermission: 'Bị từ chối quyền camera. Vui lòng bật quyền trong cài đặt trình duyệt.',
    result: 'Kết quả',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    open: 'Mở liên kết',
    delete: 'Xóa',
    scanAgain: 'Quét lại',
    privacy: 'Xử lý diễn ra cục bộ trong trình duyệt. File không rời khỏi thiết bị của bạn.',
    upload: 'Tải ảnh lên',
    paste: 'Dán (Ctrl+V)',
    drop: 'Thả ảnh vào đây',
    retry: 'Thử lại',
    errorAccessDenied: 'Bị từ chối quyền camera',
    errorCamera: 'Vui lòng cho phép truy cập camera trong cài đặt trình duyệt.',
    initializing: 'Đang khởi tạo camera...',
    cameraActive: 'Camera đang hoạt động',
    scannedItems: 'Mục đã quét',
    recentScans: 'Gần đây (lưu cục bộ)',
    clickToUpload: 'Bấm để tải lên',
    newBadge: 'MỚI',
    tabCameraMobile: 'Camera',
    tabCameraDesktop: 'Quét bằng camera',
    emptyState: {
      title: 'Chưa có lần quét nào',
      desc: 'Tải ảnh lên hoặc dùng tab camera để bắt đầu.',
    },
    highlights: {
      title: 'Quét nhanh, riêng tư',
      items: [
        { title: 'Giải mã trên thiết bị', desc: 'Mặc định không upload; an toàn cho URL/tài sản nhạy cảm.' },
        { title: 'Nhiều định dạng', desc: 'Hỗ trợ QR cùng UPC/EAN, Code 128, ITF và hơn nữa.' },
        { title: 'Thao tác nhanh', desc: 'Thả file, dán ảnh chụp màn hình, hoặc chuyển sang quét trực tiếp ngay.' },
        { title: 'Tốt trên di động', desc: 'UI và luồng camera tối ưu cho điện thoại và màn hình nhỏ.' },
      ],
    },
    intro: {
      title: 'Trình quét QR & mã vạch online',
      body: 'Giải mã QR, UPC, EAN và nhiều loại khác ngay trong trình duyệt mà không cần cài app.',
    },
    howTo: {
      title: 'Cách quét?',
      methods: [
        {
          title: 'Cách 1: Tải ảnh',
          steps: ['Bấm Tải ảnh lên', 'Chọn QR/mã vạch', 'Nhận kết quả ngay'],
        },
        {
          title: 'Cách 2: Camera',
          steps: ['Mở tab Camera', 'Cấp quyền', 'Đưa camera vào QR/mã vạch'],
        },
      ],
    },
    features: {
      title: 'Vì sao dùng trình quét này?',
      items: [
        { title: 'Lịch sử cục bộ', desc: 'Các lần quét gần đây chỉ lưu trên thiết bị của bạn, sẵn sàng để sao chép hoặc mở lại.' },
        { title: 'Giải mã ảnh khi offline', desc: 'Tải lên hoặc dán ảnh để giải mã ngay cả khi mất kết nối.' },
        { title: 'Thao tác nhanh', desc: 'Sao chép, mở hoặc xóa kết quả ngay với điều khiển gọn gàng.' },
      ],
    },
    useCases: {
      title: 'Tình huống phổ biến',
      items: [
        { title: 'Bán lẻ & mua sắm', desc: 'Kiểm tra URL sản phẩm, coupon hoặc hướng dẫn.' },
        { title: 'Nhóm kho', desc: 'Xác minh mã vạch và quản lý cập nhật tồn kho.' },
        { title: 'Người dùng hằng ngày', desc: 'Mở nhanh menu, liên kết Wi‑Fi hoặc danh thiếp.' },
      ],
    },
    faq: {
      title: 'FAQ trình quét',
      items: [
        { q: 'Tôi có thể quét mã vạch không?', a: 'Có. Trình quét hỗ trợ QR cùng Code 128, UPC, EAN, ITF và nhiều loại khác.' },
        { q: 'Bạn có lưu lịch sử quét của tôi không?', a: 'Không. Không có lần quét nào rời khỏi trình duyệt; mọi thứ ở lại trên thiết bị của bạn.' },
        { q: 'Tôi có thể dán ảnh chụp màn hình không?', a: 'Có. Nhấn Ctrl+V (Cmd+V) để dán từ clipboard.' },
        { q: 'Có hoạt động offline không?', a: 'Tải ảnh lên hoạt động offline; quét bằng camera cần quyền và trình duyệt hỗ trợ.' },
      ],
    },
  },
  blog: {
    title: 'Góc nhìn & Hướng dẫn',
    subtitle: 'Thực hành tốt nhất, ý tưởng marketing và cập nhật sản phẩm cho trải nghiệm QR.',
    readMore: 'Đọc bài',
    back: 'Quay lại blog',
    notFound: 'Không tìm thấy bài viết',
  },
  common: {
    footer: 'Bộ công cụ tạo QR mạnh mẽ cho marketer, designer và đội nhóm.',
    privacy: 'Quyền riêng tư',
    terms: 'Điều khoản',
    contact: 'Liên hệ',
    scanToOpen: 'Quét để mở trên di động',
    help: 'Trợ giúp',
    free: 'Miễn phí',
    product: 'Sản phẩm',
    resources: 'Tài nguyên',
    company: 'Công ty',
    api: 'API (Sắp ra mắt)',
    systemStatus: 'Hệ thống hoạt động bình thường',
    footerDesc:
      'Trình tạo và quét QR tiên tiến nhất. Nhanh, ưu tiên riêng tư và miễn phí mãi mãi cho sử dụng cá nhân và thương mại.',
  },
};
